
import VoiceNoteRecorder from '../../../components/VoiceNoteRecorder';
import { inputStyle, labelStyle, stepDescStyle } from '../styles';

/**
 * Notes, and everything the wizard is about to save, in one list.
 *
 * The last chance to notice something is wrong while the specimen is still
 * within reach. Notes can be said as well as typed: voice notes recorded
 * here go up once the collection exists (useCollectionWizard).
 */
export default function Step6({
  t, form, onFormChange, vegetation, photos, extraPhotos, vegUnknownPhoto,
  audioNotes = [], setAudioNotes, saving = false,
}) {
  return (
  <div>
    <p style={stepDescStyle}>{t('step6.desc')}</p>
    <label style={{ ...labelStyle, marginBottom: 16 }}>
      {t('step6.notesLabel')}
      <textarea name="general_notes" title={t('tip.generalNotes')} value={form.general_notes} onChange={onFormChange}
        rows={8} style={{ ...inputStyle, minHeight: 160, resize: 'vertical', fontFamily: 'inherit' }}
        placeholder={t('step6.notesPlaceholder')} />
    </label>
    {setAudioNotes && (
      <div style={{ marginBottom: 16 }}>
        <VoiceNoteRecorder value={audioNotes} onChange={setAudioNotes} disabled={saving} testId="wizard-voice" />
      </div>
    )}
    <div style={{ background: 'var(--c-bg-subtle)', border: '1px solid var(--c-border)', borderRadius: 8, padding: '12px 16px', fontSize: 13, color: 'var(--c-text-body-fg)' }}>
      <div style={{ fontWeight: 600, marginBottom: 8 }}>{t('step6.summary')}</div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '4px 16px' }}>
        {[
          [t('step6.summaryQrUid'), form.qr_uid],
          [t('step6.summaryRegion'), form.region ? t(form.region, { ns: 'regions' }) : null],
          [t('step6.summaryGps'), form.gps_lat ? `${form.gps_lat}, ${form.gps_lng}` : null],
          [t('step6.summarySubstrate'), form.substrate ? t(`substrate.${form.substrate}`) : null],
          [t('step6.summaryVegetation'), vegetation.length > 0 ? vegetation.map(v => v.species === 'unknown' ? t('vegSpecial.unknown') : v.species).join(', ') : null],
          [t('step6.summarySize'), form.fruiting_body_size ? t(`size.${form.fruiting_body_size}`) : null],
          [t('step6.summarySizeEstimated'), form.fruiting_body_size_estimated ? t('common:yes') : null],
          [t('step6.summaryStage'), form.phenological_stage ? t(`stage.${form.phenological_stage}`) : null],
          [t('step6.summaryCount'), form.fruiting_body_count !== '' ? form.fruiting_body_count : null],
          [t('step6.summaryGrowthPattern'), form.growth_pattern ? t(`growthPattern.${form.growth_pattern}`) : null],
          [t('step6.summaryTaxon'), form.current_taxon_name],
          [t('step6.summaryRank'), form.current_rank ? t(`common:rank.${form.current_rank}`) : null],
          [t('step6.summaryConfidence'), form.current_confidence ? t(`common:confidence.${form.current_confidence}`) : null],
          [t('step6.summaryPhotos'), t('step6.photosAttached', { count: Object.keys(photos).length + (vegUnknownPhoto ? 1 : 0) + extraPhotos.length })],
        ].map(([lbl, val]) => val ? (
          <div key={lbl}><span style={{ color: 'var(--c-text-muted-fg)' }}>{lbl}: </span>{val}</div>
        ) : null)}
      </div>
    </div>
  </div>
  );
}
